<!-- eslint-disable-next-line -->
<template>
  <div
    :class="containerClass"
    v-if="canIUse"
    :id="`${id}-check-permissions`"
    :data-permission="permission"
  >
    <b-tooltip
      v-if="showPermissions"
      :target="`${id}-check-permissions`"
      :show.sync="showPermissions"
      :title="permission"
      :delay="{ show: 10, hide: 50 }"
      style="z-index: 10000"
    />
    <slot/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  BTooltip
} from 'bootstrap-vue';
import { uuid } from 'vue-uuid';

export default {
  data() {
    return {
      id: ''
    };
  },
  components: {
    BTooltip
  },
  props: {
    permission: {
      type: String,
      required: true
    },
    containerClass: {
      type: String
    }
  },
  computed: {
    ...mapGetters('DeveloperMode',
      [
        'showPermissions'
      ]),
    ...mapGetters('Usuario', ['hasPermission']),
    canIUse() {
      return !this.permission || this.permission === '*' || this.hasPermission(this.permission);
    }
  },
  mounted() {
    this.id = uuid.v4();
  }
};
</script>
